const typography = {
  lineHeight: '14px',
  letterSpacing: '0',
};

export default {
  Table: {
    parts: ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'],
    baseStyle: {},
    sizes: {},
    variants: {
      default: {
        tr: {
          borderBottom: 'light',
          borderBottomColor: 'border.base',
          _last: {
            borderBottom: 'none',
          },
          ...typography,
        },
        th: {
          color: 'gray.800',
          pl: '0px',
          pr: '0px',
          paddingBottom: '5',
          textTransform: 'none',
          fontSize: 'xs',
          borderBottom: 'light',
          borderBottomColor: 'border.base',
          ...typography,
        },
        td: {
          pl: '0px',
          pr: '0px',
          fontSize: 'sm',
          fontFamily: 'Poppins',
          lineHeight: '18px',
          _last: {
            display: 'flex',
            justifyContent: 'flex-end',
          },
          ...typography,
        },
      },
      history: {
        table: {
          overflowWrap: 'break-word',
          pb: '6px',
          ...typography,
        },
        tr: {
          width: '100px',
          borderBottom: 'light',
          borderBottomColor: 'border.base',
          _last: {
            borderBottom: 'none',
          },
          ...typography,
        },
        th: {
          color: 'gray.800',
          textTransform: 'none',
          width: '200px',
          wordWrap: 'break-word',
          fontSize: 'm',
          borderBottom: 'light',
          borderBottomColor: 'border.base',
          ...typography,
        },
        td: {
          color: 'gray.800',
          whiteSpace: 'pre-wrap',
          width: '200px',
          wordWrap: 'break-word',
          overflowWrap: 'anywhere',
          fontSize: '13px',
          fontFamily: 'Poppins',
          lineHeight: '18px',
          pr: '0',
          ...typography,
        },
        thead: {
          pl: '0px',
          pr: '0px',
          backgroundColor: '#E9E8E9',
        },
      },
    },
    defaultProps: {
      variant: 'default',
    },
  },
};
